import { render, staticRenderFns } from "./ExaminationRecordsAdd.vue?vue&type=template&id=65394384&scoped=true&"
import script from "./ExaminationRecordsAdd.vue?vue&type=script&lang=js&"
export * from "./ExaminationRecordsAdd.vue?vue&type=script&lang=js&"
import style0 from "./ExaminationRecordsAdd.vue?vue&type=style&index=0&id=65394384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65394384",
  null
  
)

export default component.exports